import { Component, type ErrorInfo, type ReactNode } from 'react';
import RetryCard from './RetryCard';

type ErrorBoundaryProps = {
  children?: ReactNode;
  onError?: Component<unknown, unknown>['componentDidCatch'];
};

type ErrorBoundaryState = {
  hasError: boolean;
};

export default class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    this.props.onError?.(error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <RetryCard
          title="Something went wrong"
          description="Try refreshing the page or come back in a moment."
          onRetry={() => window.location.reload()}
        />
      );
    }
    return this.props.children;
  }
}
